



















































































import {Order} from '@/model/Order';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Inject} from "vue-typedi";
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import {OrderService} from "@/services/OrderService";
import ProductLinePanel from "@/components/orders/ProductLinePanel.vue";
import ZonePicto from "@/components/ZonePicto.vue";
import CustomerData from "@/components/CustomerData.vue";
import formatDate from '@/filters/DateFormatter';
import formatDuration from '@/filters/DurationFormatter';
import formatStoreLabel from '@/filters/StoreLabelFormatter';
import {OrderState} from '@/model/OrderState';
import {EventBus} from "@/helpers/EventBus";
import {OrderedProductStatuses} from '@/model/OrderedProductStatus';
import {Zone} from '@/model/Zone';
import {StoreService} from '@/services/StoreService';
import {OrderedProductService} from '@/services/OrderedProductService';
import {ProductService} from '@/services/ProductService';
import {ModifiedQuantity} from '@/model/order/ModifiedQuantity';
import {Product} from '@/model/product/Product';
import ConfirmDialog from '@/components/dialog-box/ConfirmDialog.vue';
import OutOfStockDialogWithCheckbox from '@/components/dialog-box/OutOfStockDialogWithCheckbox.vue';
import {Drive} from "@/model/Drive";
import {CreateSupportRequest} from "@/model/support/CreateSupportRequest";
import {ConvertProductService} from "@/services/ConvertProductService";
import {SupportService} from "@/services/SupportService";
import {Support} from "@/model/support/Support";

dayjs.extend(duration);


    @Component({
      components: {ProductLinePanel, ZonePicto, ConfirmDialog, OutOfStockDialogWithCheckbox, CustomerData},
      filters: {formatDate, formatDuration, formatStoreLabel}
    })
    export default class OrderPanel extends Vue {

        @Prop({default: {}}) order: Order;
        @Prop({default: false}) isDisplayed: boolean;
        @Prop({default: false}) public canHandleSupports: boolean;

        @Inject()
        orderService!: OrderService;
        @Inject()
        storeService!: StoreService;
        @Inject()
        productService!: ProductService;
        @Inject()
        orderedProductService!: OrderedProductService;
        @Inject()
        productConverter!: ConvertProductService;
        @Inject()
        supportService!: SupportService;

        public isProcessedCommandDialogOpen: boolean = false;
        public isProcessedCommandDialogOpenWithOutOfStock: boolean = false;
        public isResumeOrderPreparation: boolean = false;
        public isUpdateOrderPreparation: boolean = false;
        public resumeDialogText: string = 'Souhaitez-vous reprendre la commande déjà commencée ?';
        public updateDialogText: string = 'Souhaitez-vous modifier la commande déjà préparée ?';
        public outOfStockList: string[] = [];
        public processedQuantityList: ModifiedQuantity[] = [];
        public orderState = OrderState;
        supports: Support[] = [];

        public changeOrderState(newState: OrderState) {
            this.orderService.changeOrderState(this.order.orderNumber, this.order.zone, newState, this.order.products)
                .then((res: Order[]) => {
                    if (res == null) {
                        return;
                    }

                    for (let order of res) {
                        if (newState === OrderState.PROCESSING) {
                            EventBus.$emit(EventBus.PREPARE_ORDER, order);
                        }
                        EventBus.$emit(EventBus.CHANGE_ORDER_STATE, order);
                    }
                });
        }

        public populateProcessedQuantities() {
            this.processedQuantityList.forEach(processedQuantity => {
                const productToUpdate = this.order.products.find(product => product.cug === processedQuantity.cug);
                productToUpdate.processedQuantity = processedQuantity.quantity;
            });
        }

        public outOfStockAndProcessed(selectedProducts: string[]) {
            for(let label of selectedProducts){
                const productToUpdate = this.order.products.find(product => product.label === label);
                this.productService.updateProductOutOfStockStatus(this.order.zone, productToUpdate.cug).then((product : Product) => {
                    EventBus.$emit(EventBus.UPDATE_PRODUCT_OUT_OF_STOCK_STATUS, {});
                });
            }
            this.continueOrderProcessing();
        }

      public continueOrderProcessing() {
        this.outOfStockList = [];
        this.confirmProcessed(OrderState.PROCESSED);
      }

        public confirmProcessed(newState: OrderState){
            this.displayOrderCard();
            this.populateProcessedQuantities();
            this.changeOrderState(newState);
            this.createSupport();
        }

        public async createSupport() {
          const createSupportRequest: CreateSupportRequest = this.createSupportRequest();
          if(createSupportRequest.products != null && createSupportRequest.products.length > 0) {
            const createdSupport = await this.supportService.createSupport(createSupportRequest);
            await this.supportService.prepareSupportForCollection(createdSupport.code);
          }
        }

        public createSupportRequest(): CreateSupportRequest {
          const createSupportRequest = new CreateSupportRequest();
          createSupportRequest.orderNumber = this.order.orderNumber;
          createSupportRequest.zoneCode = this.order.zone;
          createSupportRequest.driveId = this.order.driveId;
          createSupportRequest.deliveryType = this.order.type;
          createSupportRequest.storeId = this.order.storeId;
          createSupportRequest.plannedSlot = this.order.dueDate;
          createSupportRequest.products = this.order.products
            .filter(product => product.processedQuantity.value > 0)
            .map(product => this.productConverter.convertOrderProductToSupportProduct(product));
          createSupportRequest.supportCode = "0";
          createSupportRequest.collectionSlot = this.order.dueDate;
          return createSupportRequest;
        }

        public displayOrderCard() {
            this.$emit('clickCard', this.order.orderId);
        }

      public checkQuantityValueByProduct() {
        if (this.isOrderReady || this.order.isCateringService) {
          this.isProcessedCommandDialogOpen = true;
          return;
        }

        const outOfStock = this.order.products.filter(product => {
          if (product.status === OrderedProductStatuses.PREPARED) {
            return false;
          }

          const processed = this.processedQuantityList.find(e => e.cug === product.cug);
          if (processed == null) {
            return false;
          }

          return processed.quantity.value < product.quantity.value && !this.outOfStockList.includes(product.label);
        });

        this.outOfStockList = outOfStock.map(p => p.label);

        this.isProcessedCommandDialogOpenWithOutOfStock = this.outOfStockList.length > 0;

        if (!this.isProcessedCommandDialogOpenWithOutOfStock) {
          this.isProcessedCommandDialogOpen = true;
        }
      }

      public updateProcessedQuantity(modifiedQuantity: ModifiedQuantity) {
        const index = this.processedQuantityList.findIndex(e => e.cug === modifiedQuantity.cug);

        if (index !== -1) {
          this.processedQuantityList[index] = modifiedQuantity;
        } else {
          this.processedQuantityList.push(modifiedQuantity);
        }
      }

      public cancelDialog() {
            this.isProcessedCommandDialogOpen = false;
        }

        public cancelDialogOutOfStock() {
            this.outOfStockList = [];
            this.isProcessedCommandDialogOpenWithOutOfStock = false;
        }

      public resumeOrderPreparation(orderPickerId: string): void {
        if(this.order.orderPickerId === orderPickerId) {
          this.resumeOrder();
          return;
        }
        if (orderPickerId && this.order.orderPickerName) {
          this.resumeDialogText = `Souhaitez-vous reprendre la commande en cours de préparation par ${this.order.orderPickerName} ?`;
        } else {
          this.resumeDialogText = `Souhaitez-vous reprendre la commande en cours de préparation ?`;
        }
        this.isResumeOrderPreparation = true;
      }

      public updateOrderPreparation(orderPickerId: string): void {
        if (orderPickerId && this.order.orderPickerName) {
          this.updateDialogText = `Souhaitez-vous modifier la commande préparée par ${this.order.orderPickerName} ?`;
        }
        this.isUpdateOrderPreparation = true;
      }

      public cancelResumeOrder() {
        this.isResumeOrderPreparation = false;
      }

      public cancelUpdateOrder() {
        this.isUpdateOrderPreparation = false;
      }

      resumeOrder() {
        this.orderService.assignOrderPicker(this.order.orderNumber, this.order.storeId ,this.order.zone)
            .then((res: Order[]) => {
              if (res == null) {
                return;
              }
              for (let order of res) {
                  EventBus.$emit(EventBus.PREPARE_ORDER, order);
              }
            });
        this.isResumeOrderPreparation = false
      }

        get canUpdateOrder(): boolean {
          return this.order.status.toString() === OrderState[OrderState.PROCESSED] && (this.order.updateOrderRequirements?.missingProducts || this.order.updateOrderRequirements?.supportToDropOff);
        }

        public get canProcessOrder(): boolean {
            return this.order.status.toString() === OrderState[OrderState.PROCESSING] || this.order.status.toString() === OrderState[OrderState.TO_PROCESS];
        }

        get canChangeProductQuantity(): boolean {
            return !this.canHandleSupports && this.order.status.toString() === OrderState[OrderState.PROCESSING];
        }

        get canValidateProductQuantity(): boolean {
            return !this.canHandleSupports && (this.order.status.toString() === OrderState[OrderState.PROCESSING] || (this.isOrderReady && this.canProcessOrder));
        }
        
        get zoneLabel(): string {
            const zone: Zone = this.storeService.allZones.find(zone => zone.zoneCode === this.order.zone);

            if (zone == null) {
                return null;
            }

            return zone.zoneLabel;
        }

        get isOrderProcessing(): boolean {
            return this.order.products.some(product => product.status === OrderedProductStatuses.PREPARED);
        }

        get isOrderReady(): boolean {
            return !this.order.products.some(product => product.status === OrderedProductStatuses.TO_PREPARE);
        }

        get remainingTime(): duration.Duration {
            const dueDate = dayjs(new Date(this.order.dueDate));
            const now = dayjs();

            return dayjs.duration(dueDate.diff(now));
        }

        get processingTime(): duration.Duration {
            const processingDate = dayjs(new Date(this.order.processingDate));
            const now = dayjs();

            return dayjs.duration(now.diff(processingDate));
        }

        get isTimedOut(): boolean {
            return !this.remainingTime || this.remainingTime.asMinutes() < 0;
        }

        get driveLabel(): string {
            const storeDrives = sessionStorage.getItem("storeDrives");
            if (storeDrives == null || storeDrives.length <= 1) {
                return this.order.driveId;
            }
            const drive: Drive = (JSON.parse(storeDrives) as Drive[]).find(drive => drive.driveId == this.order.driveId);
            if (drive == null) {
                return this.order.driveId;
            }
            return drive.driveLabel;
        }
    }
